import React from 'react'
import IconBase from 'react-components/atoms/IconBase/IconBase'

function Zoom({ className }) {
  return (
    <IconBase name="zoom" w={30} className={className}>
      <path
        d="M20.6667 18.6667H19.6133L19.24 18.3067C20.5467 16.7867 21.3333 14.8133 21.3333 12.6667C21.3333 7.88 17.4533 4 12.6667 4C7.88 4 4 7.88 4 12.6667C4 17.4533 7.88 21.3333 12.6667 21.3333C14.8133 21.3333 16.7867 20.5467 18.3067 19.24L18.6667 19.6133V20.6667L25.3333 27.32L27.32 25.3333L20.6667 18.6667ZM12.6667 18.6667C9.34667 18.6667 6.66667 15.9867 6.66667 12.6667C6.66667 9.34667 9.34667 6.66667 12.6667 6.66667C15.9867 6.66667 18.6667 9.34667 18.6667 12.6667C18.6667 15.9867 15.9867 18.6667 12.6667 18.6667Z"
        //  fill="#323232"
      />
      <path
        d="M16 13.3333H13.3333V16H12V13.3333H9.33334V12H12V9.33334H13.3333V12H16V13.3333Z"
        // fill="#323232"
      />
    </IconBase>
  )
}

export default Zoom
